import { z } from 'zod';
import { fileFieldSchema } from '@/schemas/fileFieldSchema.ts';

export const companyLogoSchema = z.object({
  logo: fileFieldSchema,
});

export type CompanyLogoFormData = z.infer<typeof companyLogoSchema>;
export type CompanyLogoInputFormData = z.input<typeof companyLogoSchema>;
